import { FILTER } from "@/constants";
import FilterCountIndicator from "@/containers/Filters/FilterCountIndicator";
import { FilterOption } from "@/types/FilterOptions";
import { Accordion } from "@components/Accordion";

import useFilterCount from "../../hooks/useFilterCount";
import useOptionLabel from "../../hooks/useOptionLabel";
import ChannelNameSearch from "./ChannelNameSearch";

type ChannelNameProps = {
  options?: FilterOption[];
};

const ChannelName: React.FunctionComponent<ChannelNameProps> = ({
  options = [],
}) => {
  const preview = useOptionLabel(FILTER.CHANNEL_NAME, options);
  const count = useFilterCount(FILTER.CHANNEL_NAME);

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <Accordion
      value="channel-name"
      disabled={!options || options?.length === 0}
      data-testid="filter-bar--channel-name"
      preview={preview}
      indicator={<FilterCountIndicator count={count} />}
      title={L.MENTIONS_VIEW_TOOLBAR_FILTER_CHANNEL_NAME_LABEL}
    >
      <ChannelNameSearch options={options} />
    </Accordion>
  );
};

export default ChannelName;
